/** Light-theme stars — 131×23, gold #CC8F02 */
export const BrokingHeroStars = () => (
    <svg
        className="h-[23px] w-[131px] shrink-0"
        viewBox="0 0 131 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M11.5 0L14.0819 7.9463H22.4371L15.6776 12.8574L18.2595 20.8037L11.5 15.8926L4.74047 20.8037L7.32238 12.8574L0.56285 7.9463H8.91809L11.5 0Z"
            fill="#CC8F02"
        />
        <path
            d="M38.5 0L41.0819 7.9463H49.4371L42.6776 12.8574L45.2595 20.8037L38.5 15.8926L31.7405 20.8037L34.3224 12.8574L27.5628 7.9463H35.9181L38.5 0Z"
            fill="#CC8F02"
        />
        <path
            d="M65.5 0L68.0819 7.9463H76.4371L69.6776 12.8574L72.2595 20.8037L65.5 15.8926L58.7405 20.8037L61.3224 12.8574L54.5628 7.9463H62.9181L65.5 0Z"
            fill="#CC8F02"
        />
        <path
            d="M92.5 0L95.0819 7.9463H103.437L96.6776 12.8574L99.2595 20.8037L92.5 15.8926L85.7405 20.8037L88.3224 12.8574L81.5628 7.9463H89.9181L92.5 0Z"
            fill="#CC8F02"
        />
        <path
            d="M119.5 0L122.082 7.9463H130.437L123.678 12.8574L126.26 20.8037L119.5 15.8926L112.74 20.8037L115.322 12.8574L108.563 7.9463H116.918L119.5 0Z"
            fill="#E6E6E6"
        />
        <path d="M119.5 16V0L117 8H108.5L115.5 13L112.5 21L119.5 16Z" fill="#CC8F02" />
    </svg>
);

/** shield-check — outer 20×20, black stroke for light bg */
export const BrokingShieldCheckIcon = () => (
    <span className="relative inline-block size-5 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[8.33%_16.67%_8.32%_16.67%]">
            <span className="absolute inset-[-3%_-3.75%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 14.3333 17.6695"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.66667 8.83371L6.33333 10.5004L9.66667 7.16704M13.8333 9.66704C13.8333 13.8337 10.9167 15.917 7.45 17.1254C7.26847 17.1869 7.07128 17.1839 6.89167 17.117C3.41667 15.917 0.5 13.8337 0.5 9.66704V3.83371C0.5 3.61269 0.587798 3.40073 0.744078 3.24445C0.900358 3.08817 1.11232 3.00037 1.33333 3.00037C3 3.00037 5.08333 2.00037 6.53333 0.733708C6.70988 0.582874 6.93446 0.5 7.16667 0.5C7.39887 0.5 7.62345 0.582874 7.8 0.733708C9.25833 2.00871 11.3333 3.00037 13 3.00037C13.221 3.00037 13.433 3.08817 13.5893 3.24445C13.7455 3.40073 13.8333 3.61269 13.8333 3.83371V9.66704Z"
                        stroke="black"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** chart-line — outer 20×20, black stroke for light bg */
export const BrokingChartLineIcon = () => (
    <span className="relative inline-block size-5 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[12.5%]">
            <span className="absolute inset-[-3.33%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.5 0.5V13.8333C0.5 14.2754 0.675595 14.6993 0.988155 15.0118C1.30072 15.3244 1.72464 15.5 2.16667 15.5H15.5M13.8333 5.5L9.66667 9.66667L6.33333 6.33333L3.83333 8.83333"
                        stroke="black"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** trending-up — outer 16×16 */
export const TrendingUpIcon = () => (
    <span className="relative inline-block size-4 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[29.17%_8.33%]">
            <span className="absolute inset-[-9.38%_-4.69%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 14.5833 7.91667"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.9583 0.625L8.29167 6.29167L4.95833 2.95833L0.625 7.29167M13.9583 4.625V0.625H9.95833"
                        stroke="#0DCC54"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** trending-down — outer 16×16 */
export const TrendingDownIcon = () => (
    <span className="relative inline-block size-4 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[29.17%_8.33%]">
            <span className="absolute inset-[-9.38%_-4.69%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 14.5833 7.91667"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.9583 7.29167L8.29167 1.625L4.95833 4.95833L0.625 0.625M13.9583 3.29167V7.29167H9.95833"
                        stroke="#FF0303"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** Desktop wave arches — #E6E6E6 @ 0.51 on light bg (Figma 1916:1088) */
export const BrokingHeroWaveWeb = () => (
    <svg
        width="1490"
        height="1500"
        viewBox="0 0 1490 1500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            opacity="0.51"
            d="M1489.75 0H744.875L9.15527e-05 0.000823975L0 755.323V1499.65H705.875H1489.75L1489.75 755.323L1489.75 0ZM1489.75 0L1489.75 176.519C1045.29 257.132 677.219 559.05 502.298 964.956C381.417 796.738 204.978 671.559 0 616.724L9.15527e-05 0.000823975L1489.75 0ZM0 915.037C229.935 1008.21 392.377 1234.76 392.377 1499.65H0V915.037ZM673.855 1499.65C673.855 996.087 1022.28 574.561 1489.75 465.765V1499.65H673.855Z"
            fill="#E6E6E6"
        />
    </svg>
);

/** Mobile wave — Figma 2541:36003, #E6E6E6 @ 0.51 (1043×1080) */
export const BrokingHeroWaveMobile = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1043"
        height="1080"
        viewBox="0 0 1043 1080"
        fill="none"
        className={className}
        aria-hidden
    >
        <path
            opacity="0.51"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1043 0H0V1080H1043V0ZM918.488 128.929V225.701C681.608 269.895 485.442 435.413 392.217 657.941C327.792 565.72 233.757 497.093 124.512 467.032V128.929H918.488ZM124.512 630.574C247.058 681.655 333.633 805.853 333.633 951.071H124.512V630.574ZM483.649 951.071C483.649 675.008 669.348 443.917 918.488 384.273V951.071H483.649Z"
            fill="#E6E6E6"
        />
    </svg>
);
